import { render, staticRenderFns } from "./search-light.vue?vue&type=template&id=0b3b72f5"
import script from "./search-light.vue?vue&type=script&lang=js"
export * from "./search-light.vue?vue&type=script&lang=js"
import style0 from "./search-light.less?vue&type=style&index=0&prod&lang=search-light&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports